var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackupCloud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.875 32.9427H81.4583C83.1101 32.9427 84.4531 34.2857 84.4531 35.9375V45.9748L82.7287 44.2504C82.0268 43.5485 80.8897 43.5485 80.1878 44.2504C79.4859 44.9523 79.4859 46.0894 80.1878 46.7913C80.1878 46.7913 84.9735 51.577 84.9795 51.583C85.6782 52.2816 86.8231 52.2803 87.5204 51.583L92.3121 46.7913C93.014 46.0894 93.014 44.9523 92.3121 44.2504C91.6101 43.5485 90.4731 43.5485 89.7712 44.2504L88.0468 45.9748V35.9375C88.0468 32.304 85.0918 29.349 81.4583 29.349C81.4583 29.349 71.9737 29.349 71.8757 29.349C69.5999 29.349 69.5113 32.9427 71.875 32.9427Z",
    fill: "url(#paint0_linear_19_2625)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5208 77.2657H35.9375C34.2856 77.2657 32.9427 75.9227 32.9427 74.2709V64.2336L34.667 65.958C35.3256 66.6165 36.4983 66.6676 37.2079 65.958C37.9098 65.2561 37.9098 64.119 37.2079 63.4171L32.4162 58.6254C31.7143 57.9235 30.5773 57.9235 29.8753 58.6254L25.0837 63.4171C24.3818 64.119 24.3818 65.2561 25.0837 65.958C25.7856 66.6599 26.9227 66.6599 27.6246 65.958L29.3489 64.2336V74.2709C29.3489 77.9044 32.3039 80.8594 35.9375 80.8594H45.5208C46.5128 80.8594 47.3177 80.0546 47.3177 79.0625C47.3177 78.0705 46.5128 77.2657 45.5208 77.2657Z",
    fill: "url(#paint1_linear_19_2625)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0886 41.2556C64.0886 37.7391 61.8495 34.639 58.5833 33.3943C58.4195 30.7013 57.0391 28.1768 54.7673 26.5601C52.2896 24.8264 49.1802 24.3772 46.3562 25.2943C43.3894 22.1779 38.5627 21.2537 34.5478 23.1839C30.7365 25.0533 28.6284 29.0144 29.0659 32.9965C25.1306 33.785 22.1615 37.1892 22.1615 41.2556C22.1615 45.9186 26.0407 49.7136 30.8113 49.7136C30.8113 49.7136 35.9159 49.7136 35.9375 49.7136C38.1702 49.7136 38.2592 46.1198 35.9375 46.1198H30.8113C28.0224 46.1198 25.7552 43.9369 25.7552 41.2556C25.7552 38.5913 28.0167 36.4228 31.0362 36.4218C32.3367 36.4214 33.4826 35.4064 32.9755 34.0213C31.8945 31.0944 33.2516 27.8212 36.1177 26.415C39.0049 25.0229 42.5378 25.912 44.3347 28.4857C44.847 29.2203 45.8157 29.459 46.6182 29.0612C48.5765 28.0739 50.9068 28.2447 52.6943 29.4964C54.3461 30.6709 55.1978 32.5567 54.9732 34.5361C54.8679 35.4719 55.4996 36.3306 56.4238 36.5061C58.7822 36.953 60.4948 38.9511 60.4948 41.2556C60.4948 43.9369 58.2277 46.1198 55.4388 46.1198C55.4388 46.1198 43.1807 46.1198 43.1252 46.1198C40.8608 46.1198 40.7952 49.7136 43.125 49.7136H55.4388C60.2094 49.7136 64.0886 45.9186 64.0886 41.2556Z",
    fill: "url(#paint2_linear_19_2625)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8 58.6C81.4896 58.6 82.1509 58.8739 82.6385 59.3615C83.1261 59.8491 83.4 60.5104 83.4 61.2V92.4C83.4 93.0896 83.1261 93.7509 82.6385 94.2385C82.1509 94.7261 81.4896 95 80.8 95H65.2C64.5104 95 63.8491 94.7261 63.3615 94.2385C62.8739 93.7509 62.6 93.0896 62.6 92.4V61.2C62.6 60.5104 62.8739 59.8491 63.3615 59.3615C63.8491 58.8739 64.5104 58.6 65.2 58.6H80.8ZM65.2 56C63.8209 56 62.4982 56.5479 61.523 57.523C60.5479 58.4982 60 59.8209 60 61.2V92.4C60 93.7791 60.5479 95.1018 61.523 96.077C62.4982 97.0521 63.8209 97.6 65.2 97.6H80.8C82.1791 97.6 83.5018 97.0521 84.477 96.077C85.4521 95.1018 86 93.7791 86 92.4V61.2C86 59.8209 85.4521 58.4982 84.477 57.523C83.5018 56.5479 82.1791 56 80.8 56H65.2Z",
    fill: "url(#paint3_linear_19_2625)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73 92.4C73.6896 92.4 74.3509 92.126 74.8385 91.6384C75.3261 91.1508 75.6 90.4895 75.6 89.8C75.6 89.1104 75.3261 88.4491 74.8385 87.9615C74.3509 87.4739 73.6896 87.2 73 87.2C72.3105 87.2 71.6491 87.4739 71.1615 87.9615C70.674 88.4491 70.4 89.1104 70.4 89.8C70.4 90.4895 70.674 91.1508 71.1615 91.6384C71.6491 92.126 72.3105 92.4 73 92.4Z",
    fill: "url(#paint4_linear_19_2625)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_2625",
    x1: 81.4869,
    y1: 29.349,
    x2: 81.4869,
    y2: 52.1065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#954AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF005E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19_2625",
    x1: 35.9375,
    y1: 58.099,
    x2: 35.9375,
    y2: 80.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#954AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF005E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19_2625",
    x1: 43.125,
    y1: 22.1777,
    x2: 43.125,
    y2: 49.7136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#954AD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF005E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19_2625",
    x1: 73,
    y1: 56,
    x2: 73,
    y2: 97.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9847CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19_2625",
    x1: 73,
    y1: 87.2,
    x2: 73,
    y2: 92.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9847CE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackupCloud);
export default __webpack_public_path__ + "static/media/backup-cloud.55aa71addb9ab624e86f9c9103612988.svg";
export { ForwardRef as ReactComponent };